/* eslint-disable unicorn/filename-case */
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class TWIAPolicyClaimService {    
    static retrievePolicyFromPolicyCenter(id, lossDate, sessionID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('policyclaim'),
            'retrievePolicyPeriod',
            [id, lossDate, sessionID],
            additionalHeaders
        )
    }
}
